import { type ReactElement } from 'react'

import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const KNDetailsPopoverMapLoader = (): ReactElement => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: isMobile ? '20rem' : '30rem',
        height: isMobile ? '20rem' : '30rem',
        backgroundColor: '#e9ecef',
      }}
    >
      <CircularProgress size="2rem" sx={{ color: 'primary.main' }} />
    </Stack>
  )
}

export default KNDetailsPopoverMapLoader
